import { SET_TRAIN_TYPE_INFO, SET_CUR_TRAIN } from '../mutation-types'

const train = {
  state: {
    curTrainTypeInfo: {},
    curTrain: {},
  },
  getters: {
    curTrainTypeInfo: state => state.curTrainTypeInfo,
    curTrain: state => state.curTrain,
  },
  mutations: {
    [SET_TRAIN_TYPE_INFO](state, info) {
      state.curTrainTypeInfo = { ...info }
    },
    [SET_CUR_TRAIN](state, train) {
      state.curTrain = { ...train }
    },
  },
  actions: {},
}

export default train
